import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
const STORAGE_PREFIX = 'canela.sidebarSection.';
function readCollapsed(name) {
  try {
    return localStorage.getItem(STORAGE_PREFIX + name) === '1';
  } catch {
    return false;
  }
}

/**
 * Seção da barra lateral, com o cabeçalho em versalete e a seta que a recolhe —
 * como as "Categorias" e as "Etiquetas".
 */
export default class SidebarSection extends Component {
  collapsed = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.collapsed = !!this.attrs.title && readCollapsed(this.attrs.name);
  }
  view(vnode) {
    const {
      name,
      title,
      onEdit,
      editLabel,
      editIcon
    } = this.attrs;
    const contentId = `canela-sidebar-section-${name}`;
    return m("section", {
      className: classList('CanelaSidebar-section', `CanelaSidebar-section--${name}`, {
        collapsed: this.collapsed
      })
    }, title && m("div", {
      className: "CanelaSidebar-sectionHead"
    }, m("button", {
      type: "button",
      className: "CanelaSidebar-sectionHeader",
      "aria-expanded": this.collapsed ? 'false' : 'true',
      "aria-controls": contentId,
      onclick: () => this.toggle()
    }, m(Icon, {
      name: "fas fa-angle-down",
      className: "CanelaSidebar-sectionCaret"
    }), m("span", {
      className: "CanelaSidebar-sectionTitle"
    }, title)), onEdit && m("button", {
      type: "button",
      className: "CanelaSidebar-sectionEdit",
      "aria-label": editLabel,
      title: editLabel,
      onclick: onEdit
    }, m(Icon, {
      name: editIcon || 'fas fa-pencil'
    }))), !this.collapsed && m("ul", {
      className: "CanelaSidebar-sectionContent",
      id: contentId
    }, vnode.children));
  }
  toggle() {
    this.collapsed = !this.collapsed;
    try {
      localStorage.setItem(STORAGE_PREFIX + this.attrs.name, this.collapsed ? '1' : '0');
    } catch {
      // Sem armazenamento a escolha vale só até recarregar a página.
    }
  }
}
flarum.reg.add('ramon-canela', 'forum/components/SidebarSection', SidebarSection);